(() => {
  if (window.__sjdWhatsAppAttributionInitialized) return;
  window.__sjdWhatsAppAttributionInitialized = true;

  const attributionKey = 'sjd-visit-attribution-v2';
  const leadKey = 'sjd-whatsapp-lead-id-v1';
  const visitTimeoutMs = 30 * 60 * 1000;
  const whatsappNumber = '8618815683028';
  const trackedParams = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
    'gclid', 'gbraid', 'wbraid', 'sjd_country', 'sjd_adgroup', 'sjd_creative'
  ];

  const safeSessionStorage = {
    get(key) {
      try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
    },
    set(key, value) {
      try { window.sessionStorage.setItem(key, value); } catch (error) { /* Continue without persistence. */ }
    }
  };

  let pageAttribution;
  const readAttribution = () => {
    if (pageAttribution) return pageAttribution;
    let saved = {};
    try { saved = JSON.parse(safeSessionStorage.get(attributionKey) || '{}'); } catch (error) { saved = {}; }
    const now = Date.now();
    const params = new URLSearchParams(window.location.search);
    const currentParams = {};
    trackedParams.forEach((name) => {
      const value = params.get(name);
      if (value) currentParams[name] = value.slice(0, 300);
    });
    let externalReferrer = '';
    try {
      const referrerUrl = new URL(document.referrer);
      if (referrerUrl.hostname !== window.location.hostname) externalReferrer = referrerUrl.hostname.toLowerCase();
    } catch (error) { /* Direct or unavailable referrer. */ }
    const hasNewCampaign = Object.entries(currentParams).some(([name, value]) => saved[name] !== value);
    const validVisit = saved.last_seen_at && now - saved.last_seen_at < visitTimeoutMs;
    // New tagged arrivals and external referrers start a new attribution window.
    if (!validVisit || hasNewCampaign || externalReferrer) {
      saved = {
        ...currentParams,
        first_landing_page: window.location.pathname + window.location.search,
        landing_page: window.location.pathname + window.location.search,
        referrer_host: externalReferrer,
        first_visit_at: new Date(now).toISOString()
      };
      safeSessionStorage.set(leadKey, '');
    }
    const medium = (saved.utm_medium || '').toLowerCase();
    const source = (saved.utm_source || '').toLowerCase();
    const searchReferrer = /(^|\.)(google|bing|yahoo|duckduckgo|baidu|yandex)\./i.test(saved.referrer_host || '');
    if (saved.gclid || saved.gbraid || saved.wbraid || (source === 'google' && /^(cpc|ppc|paid|paid_search)$/.test(medium))) {
      saved.channel = 'google_ads';
    } else if (/^(cpc|ppc|paid|paid_search)$/.test(medium)) {
      saved.channel = 'other_paid';
    } else if (medium === 'organic' || (searchReferrer && !saved.utm_medium)) {
      saved.channel = 'organic_search';
    } else if (saved.referrer_host) {
      saved.channel = 'referral';
    } else {
      saved.channel = 'unknown';
    }
    saved.last_seen_at = now;
    safeSessionStorage.set(attributionKey, JSON.stringify(saved));
    pageAttribution = saved;
    return pageAttribution;
  };

  let pageLeadId;
  const createLeadId = () => {
    if (pageLeadId) return pageLeadId;
    const existing = safeSessionStorage.get(leadKey);
    if (existing) return (pageLeadId = existing);
    const date = new Date().toISOString().slice(0, 10).replaceAll('-', '');
    const random = Math.random().toString(36).slice(2, 8).toUpperCase();
    const leadId = `SJD-${date}-${random}`;
    safeSessionStorage.set(leadKey, leadId);
    return (pageLeadId = leadId);
  };

  const locale = () => (document.documentElement.lang || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';

  // Keep the customer-facing reference short enough that it is unlikely to be
  // deleted, while the full Lead ID remains available to GA4/forms internally.
  const shortReference = (leadId, channel) => {
    const prefix = channel === 'google_ads' ? 'A' : channel === 'organic_search' ? 'O' : 'U';
    return `${prefix}${String(leadId || '').replace(/[^A-Z0-9]/gi, '').slice(-4).toUpperCase()}`;
  };

  const readQuoteContext = () => {
    const page = document.querySelector('[data-sjd-wholesale-quote-page]');
    if (!page) return { qualified: false, country: '', quantity: '', productType: '', itemCount: 0 };
    const value = (selector) => page.querySelector(selector)?.value?.trim() || '';
    const itemCount = Number(page.querySelector('[data-sjd-quote-count]')?.value || 0);
    const country = value('[name="contact[Shipping country]"]');
    const quantity = value('[name="contact[Estimated quantity]"]');
    const productType = value('[name="contact[Product type]"]') || value('[name="contact[Style number or SKU]"]');
    return {
      country,
      quantity,
      productType,
      itemCount,
      qualified: Boolean(country && quantity && (itemCount > 0 || productType))
    };
  };

  const appendReference = (message, leadId, channel, attribution = {}, preserveDetails = false) => {
    // The old footer exposed ad campaign names and click IDs to customers. Replace it
    // when an existing link is clicked again, while keeping the product request intact.
    const customerMessage = String(message || '')
      .replace(/(?:\s*(?:\||\n)\s*)(?:Lead ID|Inquiry reference|Référence (?:prospect|de demande))\s*:\s*SJD-[A-Z0-9-]+[\s\S]*$/i, '')
      .replace(/\s+(?:Ref|Réf)\s*:\s*[AOU][A-Z0-9]{4}\s*$/i, '')
      .trim();
    const generated = /^Hello, I would like a wholesale fabric quote[\s\S]*$/i.test(customerMessage) ||
      /^Bonjour, je souhaite un devis de tissus en gros[\s\S]*$/i.test(customerMessage);
    const compact = generated && !preserveDetails
      ? (locale() === 'fr' ? 'Bonjour, je souhaite connaître vos prix.' : "Hi, I'd like fabric prices.")
      : customerMessage;
    return `${compact} ${locale() === 'fr' ? 'Réf' : 'Ref'}: ${shortReference(leadId, channel)}`.trim();
  };

  const hydrateAttributionFields = (attribution, leadId) => {
    document.querySelectorAll('[data-sjd-attribution]').forEach((field) => {
      const key = field.dataset.sjdAttribution;
      if (key && attribution[key] !== undefined) field.value = attribution[key];
    });
    document.querySelectorAll('[data-sjd-lead-id]').forEach((field) => {
      field.value = leadId;
    });
  };

  const enrichWhatsAppLink = (link, recordIntent = false) => {
    const href = link.getAttribute('href') || '';
    if (!/wa\.me|wa\.link|whatsapp\.com|^whatsapp:\/\/send/i.test(href)) return;
    const attribution = readAttribution();
    const leadId = createLeadId();
    const context = readQuoteContext();
    let url;
    try { url = new URL(href, window.location.origin); } catch (error) { return; }
    // Only touch official WhatsApp destinations, never lookalike domains.
    if (!['wa.me', 'wa.link', 'api.whatsapp.com', 'web.whatsapp.com', 'www.whatsapp.com'].includes(url.hostname.toLowerCase()) &&
        !(url.protocol === 'whatsapp:' && url.hostname === 'send')) return;
    const currentMessage = url.searchParams.get('text') || link.dataset.sjdWhatsappMessage ||
      (locale() === 'fr' ? 'Bonjour, je souhaite un devis de tissus en gros. Merci de confirmer le stock et la livraison.'
        : 'Hello, I would like a wholesale fabric quote. Please confirm stock and shipping.');
    if (/^wa\.link$/i.test(url.hostname)) url = new URL(`https://wa.me/${whatsappNumber}`);
    const preserveDetails = link.dataset.sjdWhatsappRole === 'quote-page' && Boolean(context.country || context.quantity || context.productType || context.itemCount);
    url.searchParams.set('text', appendReference(currentMessage, leadId, attribution.channel, attribution, preserveDetails));
    if (link.href !== url.toString()) link.href = url.toString();
    link.dataset.sjdLeadId = leadId;
    link.dataset.sjdChannel = attribution.channel;

    if (recordIntent && context.qualified) {
      window.dispatchEvent(new CustomEvent('sjd:qualified-whatsapp-request', {
        detail: {
          element: link,
          leadId,
          shortReference: shortReference(leadId, attribution.channel),
          country: context.country || attribution.sjd_country || '',
          estimatedQuantity: context.quantity,
          productType: context.productType,
          itemCount: context.itemCount,
          campaign: attribution.utm_campaign || '',
          source: attribution.utm_source || '',
          gclid: attribution.gclid || '',
          gbraid: attribution.gbraid || '',
          wbraid: attribution.wbraid || '',
          term: attribution.utm_term || '',
          content: attribution.utm_content || '',
          landingPage: attribution.first_landing_page || ''
        }
      }));
    }
  };

  const initialAttribution = readAttribution();
  const initialLeadId = createLeadId();
  hydrateAttributionFields(initialAttribution, initialLeadId);
  window.SJDLeadAttribution = {
    getAttribution: readAttribution,
    getLeadId: createLeadId,
    getShortReference: () => shortReference(createLeadId(), readAttribution().channel),
    enrichWhatsAppLink
  };
  const prepareWidgetMessage = (form) => {
    if (!form?.matches?.('form.whatsapp-chaty-app-form')) return false;
    let destination;
    try { destination = new URL(form.getAttribute('action'), window.location.origin); } catch (error) { return false; }
    if (!['web.whatsapp.com', 'api.whatsapp.com', 'wa.me'].includes(destination.hostname)) return false;
    const field = form.querySelector('[name="text"]');
    // Do not turn an accidental empty send into an inquiry.
    if (!field?.value?.trim()) return false;
    const attribution = readAttribution();
    const leadId = createLeadId();
    // Chaty's field is a single-line input: browsers remove CR/LF from its value.
    // Use explicit separators and remove our footer before click + submit retry.
    const customerMessage = field.value
      .replace(/\s*\|\s*(?:Inquiry reference:|Référence de demande:)\s*SJD-[A-Z0-9-]+(?:\s*\|\s*Source:[^|]*)?\s*$/i, '')
      .replace(/\s+(?:Ref|Réf)\s*:\s*[AOU][A-Z0-9]{4}\s*$/i, '')
      .trim();
    field.value = appendReference(customerMessage, leadId, attribution.channel, attribution);
    form.dataset.sjdLeadId = leadId;
    form.dataset.sjdChannel = attribution.channel;
    return true;
  };
  document.addEventListener('submit', event => {
    if (!prepareWidgetMessage(event.target)) return;
    window.dispatchEvent(new CustomEvent('sjd:widget-whatsapp-send', { detail: {
      element: event.target,
      leadId: createLeadId(),
      shortReference: window.SJDLeadAttribution?.getShortReference?.() || '',
      attribution: readAttribution()
    } }));
  }, true);
  const prepareLinks = (node) => {
    if (node.matches?.('a[href]')) enrichWhatsAppLink(node);
    node.querySelectorAll?.('a[href]').forEach(link => enrichWhatsAppLink(link));
  };
  // Prepare href before opening, copying or middle-clicking. No conversion event
  // is emitted until an actual click; hydration is not customer intent.
  prepareLinks(document);
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'attributes') prepareLinks(record.target);
        else record.addedNodes.forEach(prepareLinks);
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }
  ['pointerdown', 'contextmenu', 'auxclick'].forEach(type => {
    document.addEventListener(type, event => {
      const link = event.target.closest?.('a[href]');
      if (link) enrichWhatsAppLink(link);
    }, true);
  });
  document.addEventListener('click', (event) => {
    const widgetButton = event.target.closest?.('.whatsapp-chaty-app-button');
    if (widgetButton) prepareWidgetMessage(widgetButton.closest('form'));
    const link = event.target.closest?.('a[href]');
    if (link) enrichWhatsAppLink(link, true);
  }, true);
})();
